import axios from 'axios';
import { getEnvVar } from './env';

export function getSseApiUrl() {
  return getEnvVar('VITE_REACT_APP_SSE_API_URL');
}

export function getApiUrl() {
  return getEnvVar('VITE_REACT_APP_API_URL');
}

export const cancelTokenSource = axios.CancelToken.source();
